package com.shadowings.gero.data.lessons.chapter5
import com.shadowings.gero.data.lessons.buildVocabQuizContent


import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.QuizText
import com.shadowings.gero.domain.model.SingleSelectionContent
import com.shadowings.gero.domain.model.PhoneticKeyboardContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.*

fun getRecapVerbiParticipiContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_recap_verbi_participi,
            content = Res.string.exp_content_recap_verbi_participi_nilo_1,
            face = Faces.Idle,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_verbi_participi,
            content = Res.string.exp_content_recap_verbi_participi_alyn_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_recap_verbi_participi,
            content = Res.string.exp_content_recap_verbi_participi_nilo_2,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
    )
}

fun getRecapVerbiParticipiQuizContent(words: List<Word>, languageCode: String): List<IQuizContent> {
    val verbIds = listOf(
        "MANGIARE", "DARE", "ASCOLTARE", "DIRE", "BERE",
        "USCIRE", "ENTRARE", "AMARE", "ESISTERE", "VOLARE"
    )

    // Generate vocab explanations for these words to feed buildVocabQuizContent
    val dummyExplanations = verbIds.map { id ->
        ExplanationContent(
            title = Res.string.exp_title_word_name,
            content = Res.string.exp_content_word_reading_and_meaning,
            face = Faces.Idle,
            character = Characters.Nilo,
            wordId = id
        )
    }

    val vocabQuizzes = buildVocabQuizContent(dummyExplanations, words, languageCode)

    // Participles quiz questions (True/False)
    val participiQuizzes = getParticipiIntroQuizContent()

    val verbs1Ids = setOf("MANGIARE", "DARE", "ASCOLTARE", "DIRE", "BERE")
    val verbs2Ids = setOf("USCIRE", "ENTRARE", "AMARE", "ESISTERE", "VOLARE")

    val keyboardQuizzes = vocabQuizzes.filterIsInstance<PhoneticKeyboardContent>()
    val choiceQuizzes = vocabQuizzes.filterIsInstance<SingleSelectionContent>()

    val verbs1Quizzes = (keyboardQuizzes.filter { q ->
        val w = words.find { it.gardiner == q.sentence || it.alt1 == q.sentence || it.alt2 == q.sentence }
        w?.id in verbs1Ids
    } + choiceQuizzes.filter { q ->
        val correctGardiner = (q.options.find { it.correct }?.text as? QuizText.Plain)?.text
        val w = words.find { it.gardiner == correctGardiner || it.alt1 == correctGardiner || it.alt2 == correctGardiner }
        w?.id in verbs1Ids
    }).shuffled()

    val verbs2Quizzes = (keyboardQuizzes.filter { q ->
        val w = words.find { it.gardiner == q.sentence || it.alt1 == q.sentence || it.alt2 == q.sentence }
        w?.id in verbs2Ids
    } + choiceQuizzes.filter { q ->
        val correctGardiner = (q.options.find { it.correct }?.text as? QuizText.Plain)?.text
        val w = words.find { it.gardiner == correctGardiner || it.alt1 == correctGardiner || it.alt2 == correctGardiner }
        w?.id in verbs2Ids
    }).shuffled()

    val selectedVerbs1 = verbs1Quizzes.take(4)
    val selectedVerbs2 = verbs2Quizzes.take(4)
    val selectedParticipi = participiQuizzes.shuffled().take(4)

    return (selectedVerbs1 + selectedVerbs2 + selectedParticipi).shuffled()
}
